<template>
    <div>

        <DataTable
            :fields="fields"
            :items="parentComponent.items"
            :loading="parentComponent.loading"
            :error="parentComponent.error"
            :total-rows="parentComponent.requestData.max"
            :current-page.sync="parentComponent.tableParams.page"
            :per-page.sync="parentComponent.tableParams.perPage"
            :sort-by.sync="parentComponent.tableParams.sort"
            :sort-direction.sync="parentComponent.tableParams.order"
            no-sort-reset
            no-local-sorting
        >
            <template #cell(gtin)="{item}">
                <b-link :to="{ name: 'CatalogProductVariantsDetails', params: { id: item.gtin } }">{{ item.gtin }}</b-link>
            </template>
            <template #[`cell(product.name)`]="{item}">
                <b-link :to="{ name: 'CatalogProductsDetails', params: { id: item.product.id } }">{{ item.product.name }}</b-link>
            </template>
            <template #[`cell(product.id)`]="{item}">
                <b-link :to="{ name: 'CatalogProductsDetails', params: { id: item.product.id } }">{{ item.product.id }}</b-link>
            </template>
            <template #cell(description)="{item}">
                <div v-if="item.description" class="d-flex gap-2">
                    <TruncatedTextModal :text="item.description" :button-title="$t('showWholeDescription')" :modal-title="$t('description')" />
                </div>
            </template>
            <template #cell(images)="{item}">
                <div class="d-flex gap-2 flex-wrap">
                    <ImageLoader
                        v-for="image in item.images"
                        :key="image.id"
                        :src="image.url"
                        width="50"
                        height="50"
                        preview
                    />
                </div>
            </template>
            <template #cell(action)="{item}">
                <div class="d-flex gap-1 justify-content-end">
                    <ButtonIcon size="sm" icon="eye" :to="{ name: 'CatalogProductVariantsDetails', params: { id: item.gtin } }" />
                    <ButtonIcon
                        size="sm"
                        icon="trash-2"
                        variant="danger"
                        :disabled="isItemBusy(item)"
                        :loading="requestVariants.getLoading(`delete-${item.gtin}`)"
                        hide-label-while-loading
                        @click="deleteItem(item)"
                    />
                </div>
            </template>
        </DataTable>

    </div>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';
    import TruncatedTextModal from '@/components/common/TruncatedTextModal.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
            ImageLoader,
            TruncatedTextModal,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestVariants: this.parentComponent.request,
                requestProducts: this.parentComponent.requestProducts,
                requestDuplicates: this.parentComponent.requestDuplicates,
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'gtin', label: this.$t('gtin') },
                    { key: 'code', label: this.$t('code') },
                    { key: 'product.name', label: this.$t('product') },
                    { key: 'product.id', label: this.$t('productId') },
                    { key: 'manufacturer.name', label: this.$t('manufacturer') },
                    { key: 'url', label: this.$t('url') },
                    { key: 'description', label: this.$t('description') },
                    { key: 'images', label: this.$t('images') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
        },
        methods: {
            isItemBusy(item) {
                return this.requestVariants.getLoading(`patch-${item.gtin}`) || this.requestVariants.getLoading(`delete-${item.gtin}`) /* || this.requestDuplicates.getLoading(`post-${item.gtin}`) */;
            },
            deleteItem(item) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('confirmYouWantDelete'), {
                        title: this.$t('confirm'),
                        okTitle: this.$t('yes'),
                        cancelTitle: this.$t('cancel'),
                        okVariant: 'danger',
                    })
                    .then(value => {
                        if (value) {
                            this.requestVariants
                                .id(`delete-${item.gtin}`)
                                .delete({ urlParams: { id: item.gtin } })
                                .then(this.parentComponent.fetchData)
                                .catch(() => {});
                        }
                    });
            },
        },
    };
</script>
